import { Injectable } from '@angular/core';
import { Service } from '../service.model';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable, combineLatest } from 'rxjs';
import { ServiceResult } from './service-result.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AvailableServicesService {
  constructor(private firestore: AngularFirestore) {}

  public getServices(): Observable<Array<ServiceResult>> {
    return this.firestore
      .collection<Service>(`services`)
      .snapshotChanges()
      .pipe(
        map(snapshots => {
          const results = [];
          for (const snapshot of snapshots) {
            const result = new ServiceResult();
            result.documentKey = snapshot.payload.doc.id;
            result.service = snapshot.payload.doc.data();
            results.push(result);
          }
          return results;
        })
      );
  }

  public getHighlightedServices(): Observable<Array<ServiceResult>> {
    return this.firestore
      .collection<Service>(`services`, ref => ref.limit(5))
      .snapshotChanges()
      .pipe(
        map(snapshots => {
          const results = [];
          for (const snapshot of snapshots) {
            const result = new ServiceResult();
            result.documentKey = snapshot.payload.doc.id;
            result.service = snapshot.payload.doc.data();
            results.push(result);
          }
          return results;
        })
      );
  }

  getServiceByKey(serviceKeys: string): Observable<Service> {
    return this.firestore
      .doc<Service>(`services/${serviceKeys}`)
      .valueChanges();
  }

  getServicesByKey(serviceKeys: Array<string>): Observable<Array<Service>> {
    const collection = this.firestore.collection('services');
    const queries = serviceKeys.map(key => collection.doc(key).valueChanges);
    return combineLatest(queries);
  }

  getServicesByUserKey(userKey: string): Observable<Array<ServiceResult>> {
    return this.firestore
      .collection<Service>('services', ref =>
        ref.where('userId', '==', userKey)
      )
      .snapshotChanges()
      .pipe(
        map(snapshots => {
          const results = [];
          for (const snapshot of snapshots) {
            const result = new ServiceResult();
            result.documentKey = snapshot.payload.doc.id;
            result.service = snapshot.payload.doc.data();
            results.push(result);
          }
          return results;
        })
      );
  }
}
